module.exports = __webpack_public_path__ + "static/media/ic_rekka_a.36406028.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_rekka_a.svg
// module id = 1162
// module chunks = 0